import PatientTab from 'components/patient/patientTab';
import React from 'react';
import { useNavigation } from 'react-router-dom';

const PatientDetail: React.FC = () => {
  const navigation = useNavigation();

  if (navigation.state === 'loading') {
    return <div style={{ padding: '20px' }}>Loading patient...</div>;
  }

  return <PatientTab />;
};

export default PatientDetail;
